import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';

@Injectable({
  providedIn: 'root'
})
export class CompletedOverviewService extends AbstractRestService {
    postInit(): void {
    }
  
    completedDashData(startDate?: string, endDate?: string, site?: string):Observable<GenericLambdaReturn<completedOverview>> 
    {
      let currentDateString = new Date().toLocaleDateString('en-CA');

      let params:any={};

      currentDateString ? params.CurrentDate = currentDateString:null

      startDate ? params.DateRangeStart = startDate:null
      endDate ? params.DateRangeEnd = endDate:null

      site ? params.Site = site:null
      
      return this.get({
        ApiResource: "/dashcompletedoverview",
        data: params,
        repeatCall: false
      })      
    }
  
}

export type completedOverview = {
  Site: string,
  ObjectID: string,
  Section: string,
  task_type: string,
  Completed: number,
  Total: number,
  Status: string
}
  